import { Flex, Group } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import { HiColorSwatch } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { Button, EmptyState } from '@/components';
import { trans } from '@/i18n';
import { ROUTE_PATH } from '@/routes';

const Page404 = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate(ROUTE_PATH.HOME);
  };

  return (
    <div>
      <Helmet>
        <title>{trans('login.pageTitle')}</title>
      </Helmet>

      <Flex
        className="page404"
        width="100vw"
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <EmptyState
          icon={<HiColorSwatch size={40} />}
          title={trans('page404.title')}
          description={trans('page404.subtitle')}
        >
          <Group>
            <Button onClick={goHome} colorPalette="teal">
              {trans('page404.goback')}
            </Button>
          </Group>
        </EmptyState>
      </Flex>
    </div>
  );
};

export default Page404;
